import {QbElement} from "../qb-elements/qb-element";
import {DELETE} from "../qb-fetch";

class QbMessageBase extends QbElement {
    static shadow = {mode: 'closed', sheets: ["qb-elements"]}
    #messageNode
    #moreNode
    #to

    timeout = 20000

    constructor() {
        super();
        this.contentRoot.append(...this.defaultNodes);
        this.#to = setTimeout(() => {
            if(this.matches(":hover")) return;
            this.afterTimeout;
        }, this.timeout);

        this.addEventListener('keydown', e => {
            if(/Backspace|Delete/.test(e.key)) this.handleEvent_delete(e);
        });
        // this.addEventListener('click', () => this.focus());
        this.events(this, { click: "menu" });
        this.contentRoot.adoptStyleSheets("slots");
    }




    // set new_message(value) {
    //     if(value && !this.hasClass("my-message")) this.addClass("new-message");
    //     this.parentNode.setClass(this.parentNode.querySelector(".new-message"), "new-message");
    // }

    get defaultNodes() {
        return [
            SLOT({part: "reference", name: "reference"}),
            SLOT({part: "message", name: "message"}),
            // NAV(this.interaction),
        ].filter(n => n);
    }

    get deleteButton() {
        return BUTTON({type: "button", tabindex: -1, events: [this, {click: 'delete'}]}, QbIcon("recycle"));
    }

    get afterTimeout() {
        this.removeClass("hover");
    }

    get closeMenu() {
        this.contentRoot.querySelector("dialog")?.close();
    }

    get openMenu() {
        this.contentRoot.querySelector("dialog")?.show();
    }

    get menuOpen() {
        return this.contentRoot.querySelector("dialog")?.open;
    }

    handleEvent_menu(e) {
        e.preventDefault();
        const isOpen = this.menuOpen;
        [...this.parentElement.getElementsByClassName("qb-message")].forEach(n => n.closeMenu);
        if(!isOpen) this.openMenu;
    }

    handleEvent_delete(e) {
        if(isNaN(this.itemid)) console.log("TODO Save receive status")
        this.close;
    }

    get height() { return this.getBoundingClientRect().height }

    get close() {
        this.style.opacity = '1';
        this.style.transition = 'opacity 0.3s';
        this.addEventListener('transitionend', () => {
            this.delete();
        }, {once: true});
        setTimeout(() => this.style.opacity = '0', 10);
    }

    delete() {
        if(document.activeElement === this) (this.nextElementSibling || this.previousElementSibling)?.focus();
        this.remove();
    }

    set message(value) {

        this.textContent = value;
    }
}

class Notice extends QbMessageBase {
    get interaction() {
        return this.deleteButton;
    }

    get count() { return parseInt(this.iconNode.dataset.count) || 0 }

    exchange(messageNode) {
        messageNode.iconNode.dataset.count = (this?.count || 0) + 1;
        this.parentElement.append(messageNode);
        this.remove();
    }

    get iconNode() {
        return this.cache("iconNode", SPAN({part: "from"}))
    }
}

class Progress extends QbMessageBase {
    static nodeName = "qb-message-progress";

    set message(value) {
        console.log(value);
        if('pending' in value) {
            this.dataset.status = "queue";
            this.headline.textContent = _("Queued: %{num}", {num: value.pending});
            this.style.order = "100";
            return;
        }
        this.dataset.status = value.message;
        if('finished' in value) {
            this.progressNode.value = value.finished || 0;
            this.headline.dataset.progress = value.finished ? `${(parseFloat(value.finished) || 0) * 100}%` : '-';
        }
        if('src' in value) {
            let node;
            if(value.content_type.startsWith("audio")) node = this.querySelector("audio") || AUDIO({controls: true});
            else if(value.content_type.startsWith("video")) node = this.querySelector("video") || VIDEO({controls: true});
            else if(value.content_type.startsWith("image")) node = this.querySelector("img") || IMG();
            else return;
            node.src = value.src;
            if(!node.isConnected) {
                node.addEventListener("play", evt => {
                    document.body.querySelectorAll("audio,video").forEach(n => n !== evt.target && node.pause())
                });
                this.progressNode.replaceWith(node);
            }
        }
        this.headline.textContent = value.title || "N.N.";
        if(value.transform) this.headline.dataset.after = value.transform;
    }

    get defaultNodes() {
        return [
            this.headline = HEADER(),
            this.progressNode = PROGRESS({max: 1}),
            NAV(this.interaction)
        ].filter(n => n);
    }

    get interaction() {
        return this.deleteButton;
    }

    exchange(messageNode) {
        return this;
    }

}

const subclass = {
    Chat: class extends QbMessageBase {
        static nodeName = "qb-message-chat"

        set sender_id(itemid) {
            const node = this.querySelector('[slot="message"]') || cT("qb-user", { slot: 'message', itemid, afterbegin: this });
            node.itemid = itemid;
        }

        set message(value) {
            const node = this.querySelector('[slot="message"]') ||
                cT("qb-user", { slot: 'message', beforeend: this });
            node.textContent = value;
        }

        set reference(value) {
            if(!value) return;
            if(typeof value !== "object") return;
            const {itemid, text} = value;
            const user_id = itemid.split("_")[1];
            const node = this.querySelector('[slot="reference"]') ||
                cT("qb-user", { slot: 'reference', itemid: user_id, beforeend: this });
            node.textContent = text;
        }

        // set reference(ref) {
        //     if(!ref) return;
        //     this.append(cT("qb-user", { slot: "reply", itemid: ref.user_id }, ref.text));
        // }

        update(values) {
            // debugger;
            if('sender_id' in values) this.sender_id = values.sender_id
            if('message' in values) this.message = values.message;
            if('reference' in values) this.reference = values.reference;
// debugger;
        }




        exchange(messageNode) {
            this.replaceWith(messageNode);
        }


        get interaction() {
            return [
                BUTTON({ type: "button", tabindex: -1, events: [this, {click: 'menu'}]}, QbIcon("menu")),
                DIALOG(
                    DIV(
                        this.deleteButton,
                        BUTTON({type: "button", tabindex: -1, events: [this, {click: 'reply'}]}, QbIcon("reply")),
                        BUTTON({type: "button", tabindex: -1, events: [this, {click: 'edit'}]}, QbIcon("edit")),
                        BUTTON({type: "button", tabindex: -1, events: [this, {click: 'emoji'}]}, QbIcon("emoji"))
                    )
                )];
        }

        get iconNode() {
            return this.cache("iconNode", cT("qb-user", { itemid: this.itemid, part: "from", class: "avatar" }));
        }


        handleEvent_edit(evt) {
            this.parentElement.edit(this.textContent, this);
        }

        handleEvent_reply(evt) {
            const reply = getSelection().toString() || this.textContent.substring(0, 20);
            this.parentElement.reply(reply, this);
        }

        delete() {
            DELETE("/chat", this.itemid).result({json: data => data === "ok" && super.delete()});
        }


    },

    Notice: class extends Notice {
        static nodeName = "qb-message-notice";
        timeout = 5000;

        get afterTimeout() {
            this.close;
        }
    },
    Warn: class extends Notice {
        static nodeName = "qb-message-warn";
    },
    Exception: class extends Notice {
        static nodeName = "qb-message-exception";
    },
    Error: class extends Notice {
        static nodeName = "qb-message-error";
    },
    Progress: Progress
}

Object.values(subclass).forEach(c => c.register);

export function QbMessage({itemtype, ...args}) {
    const nodeName = subclass[itemtype]?.nodeName || "qb-message-notice";
    return cT(nodeName, args);
}